import { Variants } from 'framer-motion';

const opacityVariants: Variants = {
  visible: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  hidden: {
    opacity: 0,
    pointerEvents: 'none',
  },
};

const searchVariants: Variants = {
  initial: {
    x: 0,
  },
  expanded: {
    x: -90,
  },
};

const globalTransition = { duration: 0.3, ease: 'linear' };

const globalMobileTransition = { duration: 0.15, ease: 'linear' };

const headerVariants = {
  opacityVariants,
  searchVariants,
  globalTransition,
  globalMobileTransition,
};

export default headerVariants;
